import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Heart } from 'lucide-react';
import { API, setAmbToken, apiError, C } from './ambApi';

export default function AmbassadorLogin() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const isSetPw = window.location.pathname.includes('set-password') || !!token;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [pwSet, setPwSet] = useState(false);

  const login = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/ambassador/login`, { email, password });
      setAmbToken(data.token); navigate('/ambassador/dashboard');
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };
  const setPw = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      await axios.post(`${API}/ambassador/set-password`, { token, password });
      setPwSet(true);
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: `linear-gradient(135deg, ${C.navy}, ${C.navy2})` }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-3" style={{ background: C.gold }}><Heart className="h-7 w-7 text-white" /></div>
          <h1 className="text-2xl font-bold text-white">Ambassador Portal</h1>
        </div>
        {isSetPw ? (
          pwSet ? (
            <div className="bg-white rounded-3xl shadow-2xl p-7 text-center" data-testid="amb-pw-set">
              <p className="font-semibold" style={{ color: C.ink }}>Password set! You can now log in.</p>
              <button onClick={() => navigate('/ambassador/login')} className="mt-4 w-full h-11 rounded-full text-white font-semibold" style={{ background: C.navy }}>Go to login</button>
            </div>
          ) : (
            <form onSubmit={setPw} className="bg-white rounded-3xl shadow-2xl p-7 space-y-4" data-testid="amb-setpw-form">
              {error && <div className="text-sm rounded-xl bg-red-50 border border-red-200 text-red-800 px-3 py-2.5">{error}</div>}
              <p className="text-sm" style={{ color: '#4A5560' }}>Create a password for your ambassador account.</p>
              <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 8 chars)"
                className="w-full h-12 px-3.5 rounded-xl border border-[#E3E1DC] outline-none" data-testid="amb-newpw" />
              <button type="submit" disabled={loading} className="w-full h-12 rounded-full text-white font-semibold flex items-center justify-center" style={{ background: C.navy }} data-testid="amb-setpw-submit">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Set password'}
              </button>
            </form>
          )
        ) : (
          <form onSubmit={login} className="bg-white rounded-3xl shadow-2xl p-7 space-y-4" data-testid="amb-login-form">
            {error && <div className="text-sm rounded-xl bg-red-50 border border-red-200 text-red-800 px-3 py-2.5" data-testid="amb-login-error">{error}</div>}
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
              className="w-full h-12 px-3.5 rounded-xl border border-[#E3E1DC] outline-none" data-testid="amb-email" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
              className="w-full h-12 px-3.5 rounded-xl border border-[#E3E1DC] outline-none" data-testid="amb-password" />
            <button type="submit" disabled={loading} className="w-full h-12 rounded-full text-white font-semibold flex items-center justify-center" style={{ background: C.navy }} data-testid="amb-login-submit">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Login'}
            </button>
            <div className="text-center text-sm">
              <button type="button" onClick={() => setError('Please contact the EasyPassing team to reset your ambassador password.')} style={{ color: C.navy2 }}>Forgot password?</button>
            </div>
            <p className="text-center text-xs" style={{ color: C.mute }}>Not an ambassador yet? <a href="/ambassador/apply" className="font-semibold" style={{ color: C.navy2 }}>Apply here</a></p>
          </form>
        )}
      </div>
    </div>
  );
}
